module.exports = __webpack_public_path__ + "img/logo-nav.6d830bf.png";